/** H5 主界面最大宽度（桌面端居中显示为手机壳） */
export const APP_MAX_WIDTH = 500

/** 全屏 fixed 浮层：与 #root 同宽并水平居中 */
export const appFixedViewportStyle = {
  position: "fixed" as const,
  top: 0,
  bottom: 0,
  left: "50%",
  transform: "translateX(-50%)",
  width: "100%",
  maxWidth: APP_MAX_WIDTH,
}
